import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';

// Pages
import HomePage from './pages/HomePage';
import HegnPage from './pages/HegnPage';
import KomposithegnPage from './pages/KomposithegnPage';
import PanelhegnPage from './pages/PanelhegnPage';
import SmedejernshegnPage from './pages/SmedejernshegnPage';
import RionetPage from './pages/RionetPage';
import BetonhegnPage from './pages/BetonhegnPage';
import TraebeklaedtHegnPage from './pages/TraebeklaedtHegnPage';
import StoejhegnPage from './pages/StoejhegnPage';
import IndustrihegnPage from './pages/IndustrihegnPage';

import LaagerPage from './pages/LaagerPage';
import KompositlaagePage from './pages/KompositlaagePage';
import KompositdorPage from './pages/KompositdorPage';
import PanellaagePage from './pages/PanellaagePage';
import RionetlaagePage from './pages/RionetlaagePage';
import SmedejernslaagePage from './pages/SmedejernslaagePage';
import TraebeklaedteLaagerPage from './pages/TraebeklaedteLaagerPage';

import PortePage from './pages/PortePage';
import SkydeportePage from './pages/SkydeportePage';
import FoldeportePage from './pages/FoldeportePage';
import DobbeltportePage from './pages/DobbeltportePage';

import CarportPage from './pages/CarportPage';
import SkurPage from './pages/SkurPage';
import TerrasserPage from './pages/TerrasserPage';
import TraeterrassePage from './pages/TraeterrassePage';
import KompositterrassePage from './pages/KompositterrassePage';
import FacaderPage from './pages/FacaderPage';
import VinduespartierPage from './pages/VinduespartierPage';

import ErhvervPrivatPage from './pages/ErhvervPrivatPage';
import OmHovendalsPage from './pages/OmHovendalsPage';
import ProjekterPage from './pages/ProjekterPage';
import ProjektDetailPage from './pages/ProjektDetailPage';
import ReferencerPage from './pages/ReferencerPage';
import GalleryPage from './pages/GalleryPage';
import KontaktPage from './pages/KontaktPage';
import TakPage from './pages/TakPage';
import NotFoundPage from './pages/NotFoundPage';
import AlbumOversigtPage from './pages/AlbumOversigtPage';

export default function App() {
  return (
    <Layout>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        
        {/* Hegn */}
        <Route path="/hegn" element={<HegnPage />} />
        <Route path="/komposithegn" element={<KomposithegnPage />} />
        <Route path="/industrihegn" element={<IndustrihegnPage />} />
        <Route path="/stoejhegn" element={<StoejhegnPage />} />
        <Route path="/panelhegn" element={<PanelhegnPage />} />
        <Route path="/smedejernshegn" element={<SmedejernshegnPage />} />
        <Route path="/rionet" element={<RionetPage />} />
        <Route path="/betonhegn" element={<BetonhegnPage />} />
        <Route path="/traebeklaedt-hegn-et-naturligt-valg" element={<TraebeklaedtHegnPage />} />

        {/* Låger */}
        <Route path="/laager" element={<LaagerPage />} />
        <Route path="/kompositlaage" element={<KompositlaagePage />} />
        <Route path="/kompositdor" element={<KompositdorPage />} />
        <Route path="/kompositdoer" element={<KompositdorPage />} />
        <Route path="/panellaage" element={<PanellaagePage />} />
        <Route path="/rionetlaage" element={<RionetlaagePage />} />
        <Route path="/smedejernslaage" element={<SmedejernslaagePage />} />
        <Route path="/traebeklaedte-laager" element={<TraebeklaedteLaagerPage />} />

        {/* Porte */}
        <Route path="/porte" element={<PortePage />} />
        <Route path="/skydeporte" element={<SkydeportePage />} />
        <Route path="/dobbeltporte" element={<DobbeltportePage />} />
        <Route path="/foldeporte-i-funktionelt-design" element={<FoldeportePage />} />

        {/* Uderum & Facader */}
        <Route path="/carport" element={<CarportPage />} />
        <Route path="/skur" element={<SkurPage />} />
        <Route path="/terrasser" element={<TerrasserPage />} />
        <Route path="/traeterrasse" element={<TraeterrassePage />} />
        <Route path="/kompositterrasse" element={<KompositterrassePage />} />
        <Route path="/facader" element={<FacaderPage />} />
        <Route path="/vinduespartier" element={<VinduespartierPage />} />

        {/* Firma, projekter og kontakt */}
        <Route path="/erhverv-privat" element={<ErhvervPrivatPage />} />
        <Route path="/om-hovendals" element={<OmHovendalsPage />} />
        <Route path="/projekter" element={<ProjekterPage />} />
        <Route path="/nyheder/:slug" element={<ProjektDetailPage />} />
        <Route path="/referencer" element={<ReferencerPage />} />
        <Route path="/galleri/:type" element={<GalleryPage />} />
        <Route path="/kontakt" element={<KontaktPage />} />
        <Route path="/tak-for-din-henvendelse" element={<TakPage />} />

        {/* Midlertidig album- og billedsortering */}
        <Route path="/album-oversigt" element={<AlbumOversigtPage />} />
        <Route path="/albums" element={<AlbumOversigtPage />} />
        <Route path="/billeder" element={<AlbumOversigtPage />} />

        {/* 404 */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Layout>
  );
}
